import React, { Component } from 'react';
import * as Icons from 'components/Material/SvgIcons';
import { Paper, Styles } from 'material-ui';
import VideoPreview from 'components/Widgets/VideoPreview';

const { Spacing } = Styles;

const styles = {
  root: {
    display: 'inline-block',
    // marginRight: Spacing.desktopGutterMini,
    width: Spacing.desktopKeylineIncrement * 2 + 2 * Spacing.desktopGutterMini,
    textAlign: 'center'
  },
  link: {
    display: 'block',
    padding: Spacing.desktopGutterMini
  },
  caption: {
    fontSize: '12px',
    lineHeight: '12px',
    margin: '5px'
  },
  icon: {
    width: Spacing.iconSize * 2,
    height: Spacing.iconSize * 2
  }
};

export default class File extends Component {
  isImage(extension = '') {
    return extension.match(/^(jpeg|jpg|gif|png)$/i) !== null;
  }

  isVideo(extension = '') {
    return (
      extension.match(/^(mp4|ogv|ogg|mp3|m4v|avi|flv|wmv|mov|mpeg)$/i) !== null
    );
  }

  render() {
    let { url, caption } = this.props,
      extension = url && url.split('.').pop() || '',
      mycaption = caption.split('.').pop(),
      link,
      figCaption;

    if (caption) {
      figCaption = (
        <figcaption style={styles.caption}>
          {caption.length > 20
            ? caption.replace(/\..+$/, '').substring(0, 16) + '...'
            : caption.replace(/\..+$/, '')}
        </figcaption>
      );
    }
    if (this.isImage(extension)) {
      url = url.replace(
        'coursio.s3-eu-west-1.amazonaws.com',
        'download.s.coursio.com'
      );
      link = (
        <a style={styles.link} href={url + '?name=' + caption} target="_blank">
          <img
            width={Spacing.desktopKeylineIncrement * 2}
            src={url}
            title={caption.replace(/\..+$/, '')}
          />
          {figCaption}
        </a>
      );
    } else if (this.isVideo(mycaption)) {
      // let ending;

      //   var HttpClient = function() {
      //     this.get = function(aUrl, aCallback) {
      //     var anHttpRequest = new XMLHttpRequest();
      //     anHttpRequest.onreadystatechange = function() {
      //     if (anHttpRequest.readyState == 4 && anHttpRequest.status == 200)
      //      aCallback(anHttpRequest.responseText);
      //       if(mycaption == 'mp4' || mycaption == 'ogv' || mycaption == 'ogg' || mycaption == 'mp3'  || mycaption == 'm4v'  || mycaption == 'avi'  || mycaption == 'flv'  || mycaption == 'wmv'  || mycaption == 'mov'  || mycaption == 'mpeg'){
      //         ending = url.concat('.mp4');
      //       }

      //       ending = ending.replace('coursio.s3-eu-west-1.amazonaws.com', 'download.s.coursio.com');
      //     }

      //     anHttpRequest.open( "GET", aUrl, true );
      //     anHttpRequest.send( null );
      //     }
      //   }

      //   let aClient = new HttpClient();
      //   aClient.get(url, function(response) {
      //     // do something with response
      //   });
      //
      link = (
        <a
          style={styles.link}
          href={
            url.replace(
              'coursio.s3-eu-west-1.amazonaws.com',
              'download.s.coursio.com'
            ) +
            '?name=' +
            caption
          }
          target="_blank"
        >
          <VideoPreview
            sources={[{ url: url, type: extension }]}
            style={{ width: 128 }}
          />
          {figCaption}
        </a>
      );
    } else {
      url = url && url.replace(
        'coursio.s3-eu-west-1.amazonaws.com',
        'download.s.coursio.com'
      ) || '';
      link = (
        <a style={styles.link} href={url + '?name=' + caption} target="_blank">
          <Icons.FileCloudDownload style={styles.icon} />
          {figCaption}
        </a>
      );
    }
    return (
      <Paper style={styles.root} zDepth={1}>
        {link}
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/File.js